import store from '@web-common/state/createStore';
import { actions } from '@web-common/popup_state';
import { apiHolder, apis, inWindow } from 'api';
import debounce from 'lodash/debounce';
import { getValueFromDB } from '@web-common/popup_state/dbUtils';
import { getSiteModule } from 'env_def';
const eventApi = apiHolder.api.getEventApi();
const accountApi = apiHolder.api.requireLogicalApi(apis.accountApiImpl);
if (inWindow()) {
    const id = eventApi.registerSysEventObserver('launchSuccessed', {
        func: function () {
            setTimeout(async () => {
                const triggerPopups = debounce(event => {
                    const { first_inited = false, location = null, prevLocation = null } = event.detail;
                    console.log('[popup_state] openPopWinInOrder ', event);
                    if (first_inited || (location != null && prevLocation != null && getSiteModule(location.href) !== getSiteModule(prevLocation.href))) {
                        store.dispatch(actions.openPopWinInOrder({ first: first_inited }));
                    }
                }, 1000, { leading: false, trailing: true });
                window.addEventListener('routeChange', triggerPopups);
                const stateRoot = store.getState();
                const versionInfo = stateRoot.privilegeReducer.version;
                const navigateVersion = stateRoot.privilegeReducer.navigateVersion;
                const [popUpWinItemsRes, isNewRes] = await Promise.allSettled([getValueFromDB(), accountApi.doGetAccountIsNewAccount()]);
                const popUpWinItems = popUpWinItemsRes.status === 'fulfilled' && popUpWinItemsRes.value ? popUpWinItemsRes.value : {};
                const isNewUser = isNewRes.status === 'fulfilled' && isNewRes.value;
                store.dispatch(actions.loadLocalDataAndMerge({ data: popUpWinItems, isNewUser, versionInfo, navigateVersion }));
                setTimeout(() => {
                    triggerPopups({ detail: { first_inited: true } });
                }, 100);
                eventApi.unregisterSysEventObserver('launchSuccessed', id);
            }, 1500);
        },
    });
}
